import {
  WYSIWYG_EDITOR_DEFAULT_CARET_SCROLL_MARGIN_BOTTOM,
  WYSIWYG_EDITOR_EVENT_NEW_BLOCK,
  WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT,
  WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR,
} from '../../WysiwygEditor.constants'
import {
  scrollWysiwygEditorCaretIntoView,
  scrollWysiwygEditorElementIntoView,
} from '../../WysiwygEditor.utils'

// TinyMCE prevents the native caret scrolling on Enter and `autoresize` grows
// the iframe only on keyup, so the outer scroll containers never follow the caret
export function useEditorScrollCaretIntoView({
  caretScrollMarginBottom = WYSIWYG_EDITOR_DEFAULT_CARET_SCROLL_MARGIN_BOTTOM,
}) {
  function setup(editor) {
    function handleNewBlock({ newBlock }) {
      // `ResizeContent` re-runs autoresize without the undo level and the
      // focus() that `execCommand('mceAutoResize')` adds
      editor.fire(WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT)

      scrollWysiwygEditorElementIntoView({
        editor,
        element: newBlock,
        marginBottom: caretScrollMarginBottom,
      })
    }

    function handleResizeEditor() {
      if (editor.hasFocus()) {
        scrollWysiwygEditorCaretIntoView({
          editor,
          marginBottom: caretScrollMarginBottom,
        })
      }
    }

    editor.on(WYSIWYG_EDITOR_EVENT_NEW_BLOCK, handleNewBlock)
    editor.on(WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR, handleResizeEditor)
  }

  return {
    setup,
  }
}
